<template>
  <div>
    <v-row>
      <!-- banner version Pc -->
      <v-col class="pa-0 d-none d-sm-block">
        <v-card tile class="pa-0 ma-0">
          <v-img
            class="white--text align-center"
            height="360px"
            :src="imagenListado"
            :lazy-src="imagenListado"
          >
            <v-btn
              text
              absolute
              top
              fab
              class="pa-0 ma-0 mt-8"
              height="60"
              width="60"
              elevation="0"
              @click="volverModo()"
            >
              <v-icon class="white--text ma-0 display-1 font-weight-black">mdi-arrow-left</v-icon>
            </v-btn>
            <v-card width="500" tile class="pa-4 py-6">
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title
                    class="title text-capitalize font-weight-bold mb-2"
                  >{{ ((activeNegocioObj) ? activeNegocioObj.nombre : '')}} - {{ (activeRestObj) ? activeRestObj.nombre : ''}}</v-list-item-title>
                  <v-list-item-subtitle class="subtitle-1 teal--text text--darken-2">
                    <v-icon size="18" class="mt-n1 mr-1 teal--text text--darken-2 font-weight-bold">mdi-star-outline</v-icon>
                    {{formatCocinas}}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle
                    class="subtitle-2 font-weight-light black--text mt-2"
                  >{{ (activeRestObj) ? activeRestObj.direccion : ''}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <!-- <v-card-text class="pa-0">
                <v-list dense class="py-0">
                  <v-list-item>
                    <v-list-item-content>
                      <v-rating
                        v-model="rating"
                        background-color="indigo lighten-3"
                        color="indigo"
                        small
                        readonly
                      ></v-rating>
                    </v-list-item-content>
                    <v-list-item-action>
                      <div>
                        <span class="caption">235</span>
                        <v-btn class="ma-2" text icon>
                          <v-icon>mdi-thumb-up-outline</v-icon>
                        </v-btn>
                        <span class="caption">25</span>
                        <v-btn class="ma-2" text icon>
                          <v-icon>mdi-thumb-down-outline</v-icon>
                        </v-btn>
                      </div>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-card-text>-->
              <v-card-text class="py-0">
                <v-alert
                  class="my-0 mb-2"
                  dense
                  v-model="cerrado"
                  type="info"
                >Servicio cerrado en este momento.</v-alert>
              </v-card-text>
            </v-card>
          </v-img>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <!-- banner version movil -->
      <v-col class="pa-0 d-sm-none">
        <v-card tile class="pa-0 ma-0">
          <v-img
            id="bannerRestaurante"
            class="white--text align"
            height="200px"
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.7)"
            :src="imagenListado"
            :lazy-src="imagenListado"
          >
            <v-btn
              absolute
              icon
              text
              class="pl-0 d-block d-md-none top left"
              height="60"
              width="60"
              elevation="0"
              @click="volverModo()"
            >
              <v-icon class="white--text ma-0 display-1 font-weight-black">mdi-arrow-left</v-icon>
            </v-btn>
            <v-list-item three-line dark class="p-bottom">
              <v-list-item-content>
                <v-list-item-title
                  class="title text-capitalize font-weight-bold"
                >{{ ((activeNegocioObj) ? activeNegocioObj.nombre : '')}} - {{ (activeRestObj) ? activeRestObj.nombre : ''}}</v-list-item-title>
                <v-list-item-subtitle class="subtitle-1">
                  <v-icon size="18" class="mt-n1 mr-1">mdi-star-outline</v-icon>
                  {{formatCocinas}}
                </v-list-item-subtitle>
                <v-list-item-subtitle class="">
                  <v-alert
                    class="my-0 mb-2"
                    dense
                    v-model="cerrado"
                    type="info"
                  >Servicio cerrado en este momentos</v-alert>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-img>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { formatearCocinas } from "@/utils/restaurantes.utils.js";

export default {
  name: "bannerPrincipal",
  components: {},
  data() {
    return {
      snackbarCerrado: false,
      rating: 3.5
    };
  },
  computed: {
    ...mapState({
      activeNegocioObj: state => state.pedido.negocioObjPedido,
      activeRestObj: state => state.pedido.restauranteObjPedido,
      cocinas: state => state.restaurante.cocinas,
      modo: state => state.pedido.activePedido.forma_envio
    }),
    ...mapGetters({
      restauranteAbierto: "restaurante/restauranteAbierto"
    }),
    imagenListado() {
      return this.activeNegocioObj ? this.activeNegocioObj.imagenListado : "";
    },
    formatCocinas() {
      let res =
        this.activeNegocioObj && this.activeNegocioObj.cocinas && this.cocinas
          ? formatearCocinas(this.activeNegocioObj.cocinas, this.cocinas)
          : "Despierta tu apetito";
      return res;
    },
    cerrado() {
      return this.activeRestObj.nombre && !this.restauranteAbierto;
    }
  },
  methods: {
    volverModo() {
      this.$router.push("/pedir/" + this.modo);
    }
  },
  beforeMount() {},
  mounted() {}
};
</script>

<style scoped>
.p-bottom {
  bottom: 0px !important;
  position: absolute !important;
}
.index-1 {
  z-index: 1 !important;
}
.border {
  border: 1px solid #000;
}
</style>